/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Components.Goals {
	"use strict";

    import GoalInputTypeEnum = Meevo.Components.Goals.GoalInputTypeEnum;
    import GoalCategoryEnum = Meevo.Components.Goals.GoalCategoryEnum;
	import Enum = Meevo.Model.Enum;

	export interface IGoalRowModel {
		rows: Array<IGoalRowLine>
	}

	export interface IGoalRowLine {
		title: string,
		columns: Array<IGoalColumn>,
		total: IGoalColumn,
	}

	export interface IGoalColumn {
		amount?: number,
		actualAmount?: number,
		unit?: number,
		actualUnit?: number,
		percent?: number,
		actualPercent?: number,
		goalCategory: GoalCategoryEnum,
        id: string | number,
        employeeId?: string | number,
        departmentId?: string | number,
		year?: number,
		month?: number,
		entityVersion?: number,
		tenantId?: number,
		locationId?: number,
		workingDays?: number,

		inputType: GoalInputTypeEnum,
		maxValue?: number,
		value: number,
		actualValue: number,
		diff?: number,
        disabled?: boolean,
        goalDiff?: number,
        goalDate?: Date
	}

	export class MeevoGoalRowComponent implements ng.IComponentController {
        change: Function;
        changeTotalCallback: Function;
		model: IGoalRowModel;
		disabled: boolean;
		isCountTotal: boolean;
		isShowActual: boolean;
		public actualLabel: string = 'LABEL_ACTUAL';
		public goalInputTypeEnum: Enum = GoalInputTypeEnum;
		currentYear: number = new Date().getFullYear();
		currentMonth: number = new Date().getMonth() + 1;

		changeItemColumn(itemRow) {
            this.change({ itemRow: itemRow });
		}

        changeTotal(itemRow: IGoalRowLine) {
            if (_.isFunction(this.changeTotalCallback)) {
                this.changeTotalCallback({ itemRow: itemRow });
            }
        }

		isDisabled (model: IGoalColumn) {
            return this.disabled
				|| model.disabled
				|| model.year < this.currentYear;
        }

        monthTitle(month): string {
            let titlesYear: Array<any> = [
                {
                    id: 1,
                    title: 'LABEL_MONTH_JANUARY'
                },
                {
                    id: 2,
                    title: 'LABEL_MONTH_FEBRUARY'
                },
                {
                    id: 3,
                    title: 'LABEL_MONTH_MARCH'
                },
                {
                    id: 4,
                    title: 'LABEL_MONTH_APRIL'
                },
                {
                    id: 5,
                    title: 'LABEL_MONTH_MAY'
                },
                {
                    id: 6,
                    title: 'LABEL_MONTH_JUNE'
                },
                {
                    id: 7,
                    title: 'LABEL_MONTH_JULY'
                },
                {
                    id: 8,
                    title: 'LABEL_MONTH_AUGUST'
                },
                {
                    id: 9,
                    title: 'LABEL_MONTH_SEPTEMBER'
                },
                {
                    id: 10,
                    title: 'LABEL_MONTH_OCTOBER'
                },
                {
                    id: 11,
                    title: 'LABEL_MONTH_NOVEMBER'
                },
                {
                    id: 12,
                    title: 'LABEL_MONTH_DECEMBER'
                }
            ];
            let monthItem = _.findWhere(titlesYear, { id: month });

            if (monthItem) {
                return monthItem.title;
            }
        }

	}

    angular.module('meevo.components.controls')
		.component('meevoGoalRowComponent', <angular.IComponentOptions>{
            templateUrl: 'app/components/goals/goalRow/goalRow.component.html',
			controller: MeevoGoalRowComponent,
			controllerAs: '$ctrl',
			bindings: {
				model: "=ngModel",
				disabled: "=ngDisabled",
				required: "=ngRequired",
				change: "&ngChange",
				isShowActual: "=?",
				actualLabel: "@?",
                isCountTotal: '=?',
                changeTotalCallback: '&?'
			}
		});
}
